/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import clsx from 'clsx';
import React from 'react';

export const FileExplorerGridItemCard = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      data-slot="file-explorer-grid-item"
      className={clsx('file-explorer-grid-item', className)}
      {...props}
    />
  )
);

FileExplorerGridItemCard.displayName = 'FileExplorerGridItemCard';

export function FileExplorerGridItemCardHeader({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="file-explorer-grid-item-header"
      className={clsx('file-explorer-grid-item__header', className)}
      {...props}
    />
  );
}

export function FileExplorerGridItemCardActions({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="file-explorer-grid-item-actions"
      className={clsx('file-explorer-grid-item__actions', className)}
      {...props}
    />
  );
}

export function FileExplorerGridItemCardBody({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="file-explorer-grid-item-body"
      className={clsx('file-explorer-grid-item__body', className)}
      {...props}
    />
  );
}

export function FileExplorerGridItemCardFooter({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="file-explorer-grid-item-footer"
      className={clsx('file-explorer-grid-item__footer', className)}
      {...props}
    />
  );
}

export function FileExplorerGridItemCardTitle({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="file-explorer-grid-item-title"
      className={clsx('file-explorer-grid-item__title', className)}
      {...props}
    />
  );
}

export function FileExplorerGridItemCardDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="file-explorer-grid-item-description"
      className={clsx('file-explorer-grid-item__description', className)}
      {...props}
    />
  );
}
